export function initWidget(context, { orgDomain, loginDomain, appId, orgId }) {
  context.gateways.chatGateway.configure({ orgDomain, loginDomain, appId });
  context.gateways.messageGateway.configure({ orgDomain, loginDomain, appId });
  context.gateways.selfServiceGateway.configure({ orgDomain, orgId });
}
